import { createSelector } from '@reduxjs/toolkit';

const bidReducer = (state) => state.bidReducer;

export const bidStateSelector = createSelector(bidReducer, (state) => state);

export const bidsSelector = createSelector([bidStateSelector], ({ bids }) => ({
    bids
}));

export const bidByIdSelector = (id) =>
    createSelector([bidStateSelector], ({ bids }) => bids.find((bid) => bid.id === id));
